export default __webpack_public_path__ + "static/media/0x5fcb9de282af6122ce3518cde28b7089c9f97b26.461b1d59.webp";